import React from 'react';
import ShopifyLogin from '../screens/public/ShopifyLogin';
import Login from '../screens/public/Login';
import ResetPassword from '../screens/public/ResetPassword';
import Invite from '../screens/public/Invite';

export default [
    {
        path: '/shopifyLogin',
        screen: (props) => <ShopifyLogin {...props} />,
        exact: true
    },
    {
        path: '/login',
        screen: (props) => <Login {...props} />,
        exact: true
    },
    {
        path: '/invite/:code',
        screen: (props) => <Invite {...props} />,
        exact: true
    },
    {
        path: '/signup',
        screen: (props) => <Login {...props} />,
        exact: true
    },
    {
        path: '/resetPassword',
        screen: (props) => <ResetPassword {...props} />,
        exact: true
    },
]